import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import { useMemo } from 'react';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.FooterTcA');
    const { locale = 'us' } = getLocal();

    const NA_item = [
        {
            isHead: true,
            title: t('footer_title'),
        },
        {
            isOpen: true,
            title: t('footer_title2'),
            desc: t('footer_desc'),
        },
        {
            isHead: true,
            title: t('title'),
        },
        {
            isOpen: true,
            title: t('title1'),
            desc: t('desc1'),
        },
        {
            isOpen: true,
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            isOpen: true,
            title: t('title3'),
            desc: t.rich('desc3', {
                e: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title4'),
            desc: t.rich('desc4', {
                e: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title5'),
            desc: t.rich('desc5', {
                e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
            }),
        },
    ].filter(Boolean) as EcoTextTcItemProps[];

    const EU_Item = [
        {
            isHead: true,
            title: t('footer_title'),
        },
        {
            isOpen: true,
            title: t('footer_title2'),
            desc: t('footer_desc'),
        },
        // {
        //     isHead: true,
        //     title: t('title'),
        // },
        // {
        //     isOpen: true,
        //     title: t('title2'),
        //     desc: t('desc2'),
        // },
        // {
        //     isOpen: true,
        //     title: t('title3'),
        //     desc: t('desc3'),
        // },
        // {
        //     isOpen: true,
        //     title: t('title4'),
        //     desc: t.rich('desc4', {
        //         l: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
        //     }),
        // },
        // {
        //     isOpen: true,
        //     title: t('title5'),
        //     desc: t.rich('desc5', {
        //         l: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
        //         lg: (v: string) => `<a class="link" href="https://account.ecoflow.com/login?return_to=${locale}.ecoflow.com" target="_blank">${v}</a>`,
        //     }),
        // },
        // {
        //     isOpen: true,
        //     title: t('title6'),
        //     desc: t.rich('desc6', {
        //         e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
        //         l: (v: string) => `<a class="link" href="${v}" target="_blank">${v}</a>`,
        //     }),
        // },
    ];

    const JP_Item = [
        {
            title: t('title1'),
            desc: t('desc1'),
            isOpen: true,
        },
        {
            title: t('title2'),
            desc: t.rich('desc2', {
                l: (v: string) => `<a class="link" href="https://jp.ecoflow.com/pages/online-store-policy" target="_blank">${v}</a>`,
                e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
            }),
            isOpen: true,
        },
    ];

    const AU_Item = [
        {
            isHead: true,
            title: t('footer_desc'),
        },
    ];

    const items = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return NA_item;
            case 'jp':
                return JP_Item;
            case 'eu':
            case 'uk':
            case 'de':
            case 'fr':
            case 'es':
            case 'nl':
            case 'it':
                return EU_Item;
            case 'au':
                return AU_Item;
            default:
                return NA_item;
        }
    }, [locale]);

    return (
        <>
            <EcoSpace />
            <EcoTextTc items={items} className={styles.comp} />
        </>
    );
}
